import axios from '@/plugins/axios';
import utils from '@/stores/utils';

const state = {
    allocation: {},
    allocation_loading: false,
    allocation_loading_errors: null,
    allocation_saving: false,
    allocation_saving_errors: {},
    allocation_deleting: false,
    allocation_deleting_errors: null,

    allocation_used: null,
    allocation_count: null,
    start_date: null,
    end_date: null,

    customer: null,
    product: null,
};


const mutations = {

    updateAllocation(state, allocation) {
        state.allocation = allocation;
        state.allocation_loading = false;
        state.allocation_loading_errors = null;

        state.allocation_count = allocation.count;
        state.allocation_ued = allocation.used;

        state.product = allocation.product;
        state.customer = allocation.customer;
        state.start_date = allocation.start_date;
        state.end_date = allocation.end_date;
        state.allocation_used = allocation.used;
    },
    updateProduct(state, product) {
        state.allocation.product = product;
        state.product = product;
        state.allocation.product_data = null; //state.products.find((item) => item.id == product);
    },
    updateCustomer(state, customer) {
        state.allocation.customer = customer;
        state.customer = customer;
    },

    updateAllocationLoading(state) {
        state.allocation_loading = true;
        state.allocation_loading_errors = null;
    },
    updateAllocationLoadingErrors(state, errors) {
        state.allocation_loading = false;
        state.allocation_loading_errors = errors;
    },
    updateAllocationSaving(state, saving) {
        state.allocation_saving = saving;
        state.allocation_saving_errors = {};
    },
    updateAllocationSavingErrors(state, errors) {
        state.allocation_saving = false;
        state.allocation_saving_errors = errors || {};
    },
    updateAllocationDeleting(state, deleting) {
        state.allocation_deleting = deleting;
    },
    updateAllocationDeletingErrors(state, errors) {
        state.allocation_deleting_errors = errors;
    },

    updateMinDate(state, start_date) {
        state.allocation.start_date = start_date;
        state.start_date = start_date;
    },
    updateMaxDate(state, end_date) {
        state.allocation.end_date = end_date;
        state.end_date = end_date;
    },

    updateAllocationUsed(state, used) {
        state.allocation.used = used;
        state.allocation_used = used;
    },
    updateAllocationCount(state, count) {
        state.allocation.count = count;
        state.allocation_count = count;
    },

    updateAllocations(state, allocations) {
        state.allocations = allocations;
    },
    updateAllocationsCount(state, count) {
        state.allocations_count = count;
    },
    updateAllocationsLoading(state, loading) {
        state.allocations_loading = loading;
    },
    updateAllocationsLoadingErrors(state, errors) {
        state.allocations_loading_errors = errors;
    },
};


const getters = {

};

const actions = {

    async fetchAllocation({ commit, dispatch, state }, params) {
        commit('updateAllocationLoading', true);

        try {
            let url;
            if (params && params.id) {
                url = `/api/allocations/${params.id}/`;
            } else if (state.allocation) {
                url = `/api/allocations/${state.allocation.id}/`;
            } else {
                throw 'No allocation to fetch';
            }

            const response = await axios.get(url);
            commit('updateAllocation', response.data);
            await dispatch('fetchAllocationEntries');
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateAllocationLoadingErrors', error.details);
            throw error;
        }
    },

    async fetchAllocationEntry({ commit, dispatch, state }, params) {
        commit('updateAllocationEntryLoading', true);
        commit('updateAllocationEntryLoadingErrors', null);

        try {
            let url;
            if (params && params.id) {
                url = `/api/allocationentries/${params.id}/`;
            } else if (state.allocation) {
                url = `/api/allocationentries/${state.allocationentry.id}/`;
            } else {
                throw 'No allocationentry to fetch';
            }

            const response = await axios.get(url);
            commit('updateAllocationEntryLoading', false);
            commit('updateAllocationEntry', response.data);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateAllocationEntryLoading', false);
            commit('updateAllocationEntryLoadingErrors', error.details);
            throw error;
        }
    },

    async setAllocationAsDefault({ commit, dispatch, state }, params) {
        try {
            const url = `/api/allocations/${state.allocation.id}/default/`;
            const response = await axios.post(url);
            await dispatch('fetchAllocation');
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async saveAllocation({ commit, dispatch, state }, params) {
        commit('updateAllocationSaving', true);

        try {
            let url = '/api/allocations/';
            let method = axios.post;

            if (params.instance.id) {
                url = `/api/allocations/${params.instance.id}/`;
                method = axios.put;
            }
            const response = await method(url, params.instance);
            commit('updateAllocationSaving', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateAllocationSavingErrors', error.details);
            throw error;
        }
    },

    async fetchProducts({ commit, dispatch, state }, params) {
        commit('updateProductsLoading', true);

        try {
            const response = await axios.get('/api/products/', { params: state.products_filters });
            commit('updateProducts', response.data.results);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateProductsLoadingErrors', error.details);
            throw error;
        }
    },

    init({ commit, dispatch, state }, params) {
        commit('updateAllocation', params.allocation);
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
